export const LISTAR_CENTRO_DE_CUSTOS = 'LISTAR_CENTRO_DE_CUSTOS'
export const LISTAR_CENTRO_DE_CUSTO_SELECIONADO = 'LISTAR_CENTRO_DE_CUSTO_SELECIONADO'
